import { IconProps } from '@sharefiledev/flow-web';
import { DataPreFilledType } from '../../constants';

export enum ComponentTypes {
	SignatureComponent = 'SignatureComponent',
	TextComponent = 'TextComponent',
	DateComponent = 'DateComponent',
	CheckComponent = 'CheckComponent',
	CheckGroupComponent = 'CheckGroupComponent',
	InitialsComponent = 'InitialsComponent',
	SelectComponent = 'SelectComponent',
	AttachmentComponent = 'AttachmentComponent',
	CheckmarkAnnotationComponent = 'CheckmarkAnnotationComponent',
	SignatureAnnotationComponent = 'SignatureAnnotationComponent',
	TextAnnotationComponent = 'TextAnnotationComponent',
	PaymentComponent = 'PaymentComponent',
}

export interface IRecipient {
	id: string; // uuid string
	name: string;
	isSender: boolean;
	sequence?: number;
}

export enum GroupRequirement {
	OnlyOne = 'OnlyOne',
	OneOrMore = 'OneOrMore',
}

export enum TextAlignment {
	Left = 'Left',
	Right = 'Right',
	Center = 'Center',
}

interface AllFieldsData {
	id: string;
	type: ComponentTypes;
	x: number;
	y: number;
	width: number;
	height: number;
	page: number;
	name: string;
	assignedTo: IRecipient;
	isRequired: boolean;
	groupRequirement?: GroupRequirement;
	groupName?: string;
	groupId?: string;
	fontSize?: number;
	multiline?: boolean;
	transparent?: boolean;
	value?: string;
	textAlign?: TextAlignment;
	selectOptions?: string[];
	helpText?: string;
	chargeAfterExecuted?: boolean;
	paymentAmount?: number;
	isMergeField?: boolean;
	dateFormat?: string;
	isDateSigned?: boolean;
	isSourceMapped?: boolean;
	documentTemplateId: string;
	documentTemplateType: string;
	signatureId?: string;
	isAnnotation: boolean;
	content?: React.ReactNode;
	showErrorOnResizable?: boolean;
	signatureImage?: string;
	signatureText?: string;
	signatureType?: string;
	signatureJsonData?: any;
	sequence?: number;
}

export interface Field {
	type: ComponentTypes;
	label: string;
	icon: React.FC<IconProps>;
}

export interface IPersonalSettings {
	canManageUsers: boolean;
	attachPdfOnCompletion: boolean;
	allowDrawnSignature: boolean;
	allowTypedSignature: boolean;
	reminderFrequency: string;
}

export interface IAccountSettings {
	isHipaaAccount: boolean;
	signatureColorBlueDefault: boolean;
}

export type Dimensions = {
	width: number;
	height: number;
};

export type VariablesFieldData = {
	dataPreFilledType?: DataPreFilledType;
	variableId?: string;
	attributePath?: string;
};

export type Component = AllFieldsData & VariablesFieldData;

export type UserInfo = {
	text: string;
	id: string;
	fullName: string;
	email: string;
};
